module.exports = __webpack_public_path__ + "static/media/man_05.ace31afe.png";